var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'main-bage',
    {
      'main-bage_primary': _vm.variant === 'primary',
      'main-bage_danger': _vm.variant === 'danger',
      'main-bage_success': _vm.variant === 'success',
      'main-bage_warning': _vm.variant === 'warning',
    } ]},[_vm._v("\n  "+_vm._s(_vm.content)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }